export default __webpack_public_path__ + "1d18e15e257a2ba30eed931099c10bb2.png";